import { action, computed, observable } from 'mobx';
import {
  GraphicsLayer,
  SpatialReference,
  MapView,
  Sketch,
  SceneView,
  RasterData,
  FeatureSet,
  GroupLayer,
  Geometry,
} from 'cd-eft/utils/esriTypes';
import stores from '../../../models/Stores';
import Home from '@arcgis/core/widgets/Home';

import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import { LinearUnit } from 'cd-eft/utils/structureLayerUtils';
import { TinContourSurface } from 'cd-eft/framework/TinContourSurface/TinContourSurface';
import { appConfig } from 'cd-eft/config/AppConfig';
import DemSurfaceGpApi from 'cd-eft/services/DemSurfaceGpApi/DemSurfaceGpApi';
import { zoomToSubjectArea } from 'cd-eft/utils/gisUtils';
import { ToolSlot } from 'cd-eft/_stories_/ActiveTool/StoryModel';

const {designStore } = stores.AppStore;
const setStore = stores.AppStore.surveyEngineeringStore;

export class ClippedContainerVM {
  @observable static screenshotLoading: boolean = false;
  @observable view?: MapView;
  @observable sceneView?: SceneView;
  @observable sketchWidget?: Sketch;
  @observable bpSketchWidget?: Sketch;
  @observable result_dem: RasterData | undefined;
  @observable result_dem_boundary: FeatureSet | undefined;
  @observable in_dem_file: File | undefined = undefined;
  @observable in_dem_elevation_units: string = 'feet';
  public readonly aoiGraphicsLayer: GraphicsLayer;
  public readonly aoiSketch: Sketch;
  @observable jobExecuting: boolean = false;
  public readonly sketchGroupLayer: GroupLayer;
  public readonly resultsGroupLayer: GroupLayer;
  @observable crossSectionOpen: boolean = false;
  @observable dataSourceType: string = '';
  @observable metadata: string = '';
  @observable gpsessionResourceTypeId: number = 1;
  @observable private readonly api: DemSurfaceGpApi = new DemSurfaceGpApi();
  homeWidget?: Home;
 
  @observable UIState = false; //steps 0, 1

  @observable countyExtent?: Geometry;

  // @observable notification: any = { message: '', header: '', type: 'warning', hidden: true };
  private centerPointSketch?: Sketch;
  private readonly centerPointLayer = new GraphicsLayer({ id: 'centerPointGraphic', title: 'Center Point', listMode: 'hide' });
  history;

  readonly toolSlot: ToolSlot;
  public workingSpatialReference?: SpatialReference = undefined;
  public static readonly origGpSurfaceTypeId = 5;

  private static instance: ClippedContainerVM;
  originalSurface?: TinContourSurface;
  sourceWkid = appConfig.tempHardCodes.wkid;
  sourceElevUnit: LinearUnit = 'intl-feet';
  mapElevUnit: LinearUnit = 'meters';

  public readonly demServicesGroupLayer: GroupLayer;
  constructor(history) {
    this.history = history;
    this.toolSlot = new ToolSlot();
    this.aoiGraphicsLayer = new GraphicsLayer({
      id: 'aoiGraphicsLayer',
      title: 'AOIGraphics',
      visible: true,
    });

    this.sketchGroupLayer = new GroupLayer({
      id: 'sketchGroupLayer',
      title: 'Design - Input',
      listMode: 'hide',
      layers: [
        this.aoiGraphicsLayer,
      ],
    });

    this.resultsGroupLayer = new GroupLayer({
      id: 'resultsGroupLayer',
      title: 'Design',
      layers: [],
    });

    this.demServicesGroupLayer = new GroupLayer({
      id: 'demServicesGroupLayer',
      title: 'DEM Services',
      layers: [],
    });

    this.aoiSketch = new Sketch({
      id: 'aoiSketch',
      layer: this.aoiGraphicsLayer,
      view: this.view,
      creationMode: 'single',
      visibleElements: {
        createTools: {
          point: false,
          polyline: false,
          polygon: true,
          rectangle: true,
          circle: true,
        },
        selectionTools: {
          'rectangle-selection': true,
          'lasso-selection': true,
        },
        settingsMenu: false,
        undoRedoMenu: false,
      } as any,
    });

    ClippedContainerVM.instance = this;
  }
  //pass home button into VM
  @action.bound async onMapViewMounted(mapView: MapView) {
    this.view = mapView;
    // Call the function to zoom to the desired state and county
    await zoomToSubjectArea(mapView, ClippedContainerVM, designStore);
    if(this.view.map !== undefined){
      this.view.map.add(this.centerPointLayer);
      designStore.toggle3DMap = true;
      this.aoiSketch.view = this.view;
    }
  }
  @action.bound importDEMHandler() {
    if(setStore !==undefined){
    setStore.currentDEM.demId = 'New DEM';
    setStore.currentTab = 'New DEM';
    setStore.currentDEM.demType = 10;
    setStore.isImportingNewDEM = true;
    setStore.importDEMWindowIsOpen = true;
    }
  }
  @computed static get mapView(): MapView | undefined {
    return (this.instance ? this.instance.view : undefined);
  }
  public static async loadOriginalSurface(waitForScene: boolean = false): Promise<boolean> {
    let result: boolean = false;
    if (this.instance) {
    } else {
      MessageCenter.addError('No ClippedContainerVM instance found.');
    }
    return result;
  }
}
